import { Skeleton } from "@coval/ui/skeleton"

const PLACEHOLDER_FRAMES = [
  { left: "2%", width: "14%" },
  { left: "23%", width: "9%" },
  { left: "41%", width: "17%" },
  { left: "66%", width: "8%" },
  { left: "84%", width: "12%" },
]

export function AudioFrameTracksSkeleton({
  inset,
  rows,
  label,
  continuation = false,
}: {
  inset: { leftPx: number; rightPx: number; tailPx?: number }
  rows: number
  label: string
  continuation?: boolean
}) {
  return (
    <div
      role="group"
      aria-label={label}
      aria-busy="true"
      className={continuation ? undefined : "py-1"}
    >
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="relative h-8" aria-hidden="true">
          <Skeleton
            className="absolute left-4 top-2 h-2 w-16"
            style={{ maxWidth: Math.max(0, inset.leftPx - 24) }}
          />
          <div
            className="relative h-6 overflow-hidden rounded bg-surface-1"
            style={{
              marginLeft: inset.leftPx,
              marginRight: inset.rightPx - (inset.tailPx ?? 0),
            }}
          >
            {PLACEHOLDER_FRAMES.map((position) => (
              <Skeleton
                key={position.left}
                className="absolute top-1.5 h-3"
                style={position}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
